import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { SearchSelect } from "../../forms/inputs/search-select";
import { DateInputUser } from "../DateComponent";
import { SingleInput, Single_Input_Superviser_remark } from "../../forms/inputs/InputsTransaction";
import { Action, Status } from "../constants/CommonConstants";
import { isAlphanumericAllSpecialCharacters } from "../../../../functions/validations";
import { errorstyle, normalstyle } from "../../../../functions/welding-functions";

const SESSION_CONFIG = {
  WPS: { titles: ["Prepared By - Welding Engineer", "Approved By - Welding Engineer"], signatures: ["wps_signaturePrepared", "wps_signatureApproved"], skFields: ["WPSH_PreparedBy", "WPSH_ApprovedBy"], remarkComponent: "SingleInput", padding: "28px 60px", hasRemarks: true, layout: "separate" },
  WPQ: { titles: ["Supervised By - Welding Engineer", "Approved By - Welding Engineer"], signatures: ["wpq_signaturePrepared", "wpq_signatureApproved"], skFields: ["WPSH_PreparedBy", "WPSH_ApprovedBy"], remarkComponent: "Single_Input_Superviser_remark", padding: "20px 13px", hasRemarks: true, layout: "combined" },
  PQR: { titles: ["Welding Engineer", "Witness By"], signatures: ["PQR_SignaturePrepared", "PQR_SignatureApproved"], skFields: ["WPSH_WeldingEnggBy", "WPSH_ApprovedBy"], remarkComponent: null, padding: "20px 60px", hasRemarks: false, layout: "combined" }
};

const createUserChangeHandler = (isPrepared, config, fetchUserProfile, setheaderObj, setIsEdited, action, users) => (selectedValue) => {
  if (action === Action.ActionEdit) setIsEdited(true);
  const selectedUser = users.filter(user => user.um_name === selectedValue.value)[0];
  if (selectedUser) {
    fetchUserProfile(selectedUser.wld_profile);
    setheaderObj(prev => ({
      ...prev,
      [isPrepared ? "WPSH_PreparedBy_Name" : "WPSH_ApprovedBy_Name"]: selectedUser.um_name,
      [config.signatures[isPrepared ? 0 : 1]]: selectedUser.wld_profile,
      [config.skFields[isPrepared ? 0 : 1]]: selectedUser.SK,
    }));
  }
};

const renderRemarkField = (config, isPrepared, remarkField, maxLength, isReadonly, isDisabled, Band, error, headerObj, handleChange, handleRemarkChange, setError) => {
  if (!config.hasRemarks) return null;

  const commonProps = {
    disabled: isReadonly || isDisabled,
    name: remarkField,
    maxLength,
    readOnly: isReadonly || (!isPrepared && Band !== "P" && Band !== "T"),
    status: error[remarkField]?.status,
    value: headerObj[remarkField],
    label: "Remark",
    message: error[remarkField]?.message,
    onInput: (e) => setError(prev => ({ ...prev, [remarkField]: isAlphanumericAllSpecialCharacters(e.target.value) }))
  };

  if (config.remarkComponent === "Single_Input_Superviser_remark") {
    return (
      <Single_Input_Superviser_remark
        {...commonProps}
        type={isPrepared ? "text" : "textarea"}
        style={{ height: "90px", width: isPrepared ? "102%" : "112%" }}
        handleChange={handleChange || handleRemarkChange}
      />
    );
  }

  return isPrepared ? (
    <SingleInput {...commonProps} type="text" style={{ height: "95px" }} onChange={handleRemarkChange} error={error} setError={setError} />
  ) : (
    <div className="T-input w-100">
      <textarea
        {...commonProps}
        style={{ height: "115px" }}
        type="textarea"
        id={remarkField}
        placeholder=" "
        className={error[remarkField]?.status ? "T-input placeHolderInput inputText text-field-with-error" : "T-input placeHolderInput inputText"}
        onChange={handleRemarkChange}
      />
      <Form.Label htmlFor={remarkField}>Remark</Form.Label>
      {headerObj.WPSH_Approval_Status === Status.StatusApproved && error[remarkField]?.status && (
        <div className="required-text1">
          <Form.Text className="text-danger">{error[remarkField].message}</Form.Text>
        </div>
      )}
    </div>
  );
};

export const UnifiedSignatureSection = ({
  sessionType,
  sectionType,
  headerObj,
  setheaderObj,
  users,
  error,
  setError,
  previewImage,
  previewApprovedImage,
  fetchUserProfile,
  fetchApprovedUserProfile,
  isReadonly,
  isDisabled,
  action,
  setIsEdited,
  Band,
  handleChangeRadio,
  handleChange,
  maxLength = 50,
  todayDate
}) => {
  const config = SESSION_CONFIG[sessionType];
  const isPrepared = sectionType === "prepared";
  const showActionSection = !isPrepared && (Band === "P" || Band === "T");
  const [nameField, dateField, remarkField] = ["WPSH_PreparedBy_Name", "WPSH_PreparedBy_Date", "WPSH_PreparedBy_Remark"].map(f => isPrepared ? f : f.replace("PreparedBy", "ApprovedBy"));

  // Combined Layout (WPQ and PQR)
  if ((sessionType === "WPQ" || sessionType === "PQR") && sectionType === "combined") {
    const handleUserChange = (isPreparedUser) => (prename) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      const selectedUser = users.filter(b => b.um_name === prename.value)[0];
      if (selectedUser) {
        // Update header object first
        setheaderObj(prev => ({
          ...prev,
          [isPreparedUser ? "WPSH_PreparedBy_Name" : "WPSH_ApprovedBy_Name"]: selectedUser.um_name,
          [config.signatures[isPreparedUser ? 0 : 1]]: selectedUser.wld_profile,
          [config.skFields[isPreparedUser ? 0 : 1]]: selectedUser.SK,
        }));
        // Then fetch the signature image
        (isPreparedUser ? fetchUserProfile : fetchApprovedUserProfile)(selectedUser.wld_profile);
      }
    };

    return (
      <Row style={{ padding: config.padding, position: "relative", bottom: sessionType === "PQR" ? "20px" : "0px" }}>
        <Row className="mb-4">
          <Col><span className="WPS-blue-text">{config.titles[0]}</span></Col>
          <Col style={{ paddingLeft: sessionType === "PQR" ? "0px" : "101px" }}><span className="WPS-blue-text">{config.titles[1]}</span></Col>
        </Row>
        <Row>
          {[0, 1].map(idx => (
            <React.Fragment key={idx}>
              <Col md={3} style={idx === 1 ? { position: "relative", left: sessionType === "PQR" ? "0px" : "38px" } : {}}>
                <Form.Group className="pro-input-select">
                  <div className="search-select">
                    <SearchSelect
                      id={idx === 0 ? "WPSH_PreparedBy_Name" : "WPSH_ApprovedBy_Name"}
                      name={idx === 0 ? "WPSH_PreparedBy_Name" : "WPSH_ApprovedBy_Name"}
                      className={error[idx === 0 ? "WPSH_PreparedBy_Name" : "WPSH_ApprovedBy_Name"]?.status ? "err-input" : ""}
                      stylegreen={error[idx === 0 ? "WPSH_PreparedBy_Name" : "WPSH_ApprovedBy_Name"]?.status ? errorstyle : normalstyle}
                      data={users}
                      valueField="um_name"
                      disabled={isDisabled}
                      value={headerObj[idx === 0 ? "WPSH_PreparedBy_Name" : "WPSH_ApprovedBy_Name"]}
                      labelField="um_name"
                      placeholder=""
                      onChange={handleUserChange(idx === 0)}
                    />
                  </div>
                  <Form.Label>Name</Form.Label>
                  <div className="required-text-select">
                    {error[idx === 0 ? "WPSH_PreparedBy_Name" : "WPSH_ApprovedBy_Name"]?.status && (
                      <Form.Text className="text-danger">
                        {error[idx === 0 ? "WPSH_PreparedBy_Name" : "WPSH_ApprovedBy_Name"].message}
                      </Form.Text>
                    )}
                  </div>
                </Form.Group>
              </Col>
              <Col md={3} style={idx === 1 ? { position: "relative", left: sessionType === "PQR" ? "0px" : "30px" } : {}}>
                <DateInputUser
                  divClass="T-input w-100"
                  label="Date"
                  className="groove_datecolor"
                  name={idx === 0 ? "WPSH_PreparedBy_Date" : "WPSH_ApprovedBy_Date"}
                  obj={headerObj}
                  setobj={setheaderObj}
                  setError={setError}
                  status={error[idx === 0 ? "WPSH_PreparedBy_Date" : "WPSH_ApprovedBy_Date"]?.status}
                  message={error[idx === 0 ? "WPSH_PreparedBy_Date" : "WPSH_ApprovedBy_Date"]?.message}
                  disabled={isDisabled}
                />
              </Col>
            </React.Fragment>
          ))}
          {sessionType !== "PQR" && (
            <>
              <Row className="mb-4">
                <Col style={{ position: "relative", left: "13px" }}><span>Signature Image</span></Col>
                <Col style={{ position: "relative", left: "57px" }}><span>Signature Image</span></Col>
              </Row>
              <Row style={{ position: "relative", bottom: "10px" }}>
                <Col md={6} style={{ position: "relative", left: "13px" }}>
                  <div className="signature-box"><div className="imgbox"><img className="imgsizebig1" src={previewImage} alt="prepared signature" /></div></div>
                </Col>
                <Col md={6} style={{ position: "relative", left: "58px" }}>
                  <div className="signature-box"><div className="imgbox"><img className="imgsizebig1" src={previewApprovedImage} alt="approved signature" /></div></div>
                </Col>
              </Row>
            </>
          )}
          {sessionType === "WPQ" && (
            <Row style={{ padding: "0px 15px", position: "relative", bottom: "10px", paddingTop: "3%" }}>
              <Col md={6}>
                <Single_Input_Superviser_remark
                  disabled={isDisabled}
                  name="WPSH_PreparedBy_Remark"
                  type="text"
                  style={{ height: "90px" }}
                  maxLength={50}
                  readOnly={isReadonly}
                  status={error.WPSH_PreparedBy_Remark?.status}
                  value={headerObj.WPSH_PreparedBy_Remark}
                  handleChange={handleChange}
                  label="Remark"
                  message={error.WPSH_PreparedBy_Remark?.message}
                  onInput={(e) => setError(prev => ({ ...prev, WPSH_PreparedBy_Remark: isAlphanumericAllSpecialCharacters(e.target.value) }))}
                />
              </Col>
              <Col md={6} style={{ paddingLeft: "60px" }}>
                <Single_Input_Superviser_remark
                  disabled={isDisabled}
                  name="WPSH_ApprovedBy_Remark"
                  type="textarea"
                  style={{ height: "90px" }}
                  maxLength={200}
                  readOnly={isReadonly || (Band !== "P" && Band !== "T")}
                  status={error.WPSH_ApprovedBy_Remark?.status}
                  value={headerObj.WPSH_ApprovedBy_Remark}
                  handleChange={handleChange}
                  label="Remark"
                  message={error.WPSH_ApprovedBy_Remark?.message}
                  onInput={(e) => setError(prev => ({ ...prev, WPSH_ApprovedBy_Remark: isAlphanumericAllSpecialCharacters(e.target.value) }))}
                />
              </Col>
            </Row>
          )}
          {sessionType === "WPQ" && (Band === "P" || Band === "T") && (
            <Col style={{ position: "relative", bottom: "23px", left: "53%" }}>
              <span className="WPS-blue-text">Action</span>
              <div className="d-flex mb-4" style={{ paddingTop: "10px" }}>
                {[Status.StatusApproved, Status.StatusRejected].map(value => (
                  <div key={value} className={value === Status.StatusRejected ? "ms-5" : ""}>
                    <input
                      type="radio"
                      name="WPSH_Approval_Status"
                      value={value}
                      checked={headerObj?.WPSH_Approval_Status === value}
                      onChange={handleChangeRadio}
                      disabled={isDisabled}
                    />
                    <span className="ms-2">{value === Status.StatusApproved ? "Approve" : "Reject"}</span>
                  </div>
                ))}
              </div>
            </Col>
          )}
        </Row>
      </Row>
    );
  }

  // Individual Sections (WPS, PQR)
  const handleRemarkChange = (e) => {
    if (action === Action.ActionEdit) setIsEdited(true);
    setheaderObj(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <Row style={{ padding: config.padding, position: "relative", bottom: isPrepared ? "50px" : "80px" }}>
      <Row className="mb-4">
        <Col><span className="WPS-blue-text">{config.titles[isPrepared ? 0 : 1]}</span></Col>
        {showActionSection && (
          <Col style={{ position: "relative", top: "36px", left: "22px" }}>
            <span className="WPS-blue-text">Action</span>
          </Col>
        )}
      </Row>
      <Row>
        <Col md={3}>
          <Form.Group className="preby-input-select">
            <div className="search-select">
              <SearchSelect
                required
                data={users}
                valueField="um_name"
                disabled={isReadonly || isDisabled}
                value={headerObj[nameField] || ""}
                labelField="um_name"
                onChange={createUserChangeHandler(isPrepared, config, fetchUserProfile, setheaderObj, setIsEdited, action, users)}
                className={error[nameField]?.status ? "err-input" : ""}
                stylegreen={error[nameField]?.status ? errorstyle : normalstyle}
              />
            </div>
            <Form.Label>{isPrepared ? "Prepared By" : "Approved By"}</Form.Label>
            <div className="required-text-select">
              {error[nameField]?.status && <Form.Text className="text-danger">{error[nameField].message}</Form.Text>}
            </div>
          </Form.Group>
        </Col>
        <Col md={3}>
          <DateInputUser
            divClass="T-input w-100"
            label="Date"
            className="groove_datecolor"
            name={dateField}
            disabled={isReadonly || isDisabled}
            obj={headerObj}
            setobj={setheaderObj}
            setError={setError}
            status={error[dateField]?.status}
            message={error[dateField]?.message}
            todayDate={!isPrepared ? todayDate : undefined}
          />
        </Col>
        {showActionSection && (
          <Col style={{ position: "relative", top: "25px", left: "20px" }}>
            <div className="d-flex mb-4">
              {[Status.StatusApproved, Status.StatusRejected].map(value => (
                <div key={value} className={value === Status.StatusRejected ? "ms-5" : ""}>
                  <input
                    type="radio"
                    name="WPSH_Approval_Status"
                    value={value}
                    disabled={isReadonly || isDisabled}
                    checked={headerObj.WPSH_Approval_Status === value}
                    onChange={handleChangeRadio}
                  />
                  <span className="ms-2">{value === Status.StatusApproved ? "Approve" : "Reject"}</span>
                </div>
              ))}
            </div>
          </Col>
        )}
        {sessionType !== "PQR" && (
          <>
            <Row className="mb-4">
              <Col><span>Signature Image</span></Col>
            </Row>
            <Row style={{ position: "relative", left: "10px", bottom: "10px" }}>
              <Col md={6}>
                <div className="signature-box"><div className="imgbox"><img className="imgsizebig1" src={previewImage} alt="signature" /></div></div>
              </Col>
              {config.hasRemarks && (
                <Col style={{ position: "relative", left: "28px" }}>
                  {renderRemarkField(config, isPrepared, remarkField, maxLength, isReadonly, isDisabled, Band, error, headerObj, handleChange, handleRemarkChange, setError)}
                </Col>
              )}
            </Row>
          </>
        )}
      </Row>
    </Row>
  );
};
